import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=c10cd57c&scoped=true"
import script from "./DetailCard.vue?vue&type=script&lang=js"
export * from "./DetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10cd57c",
  null
  
)

export default component.exports